"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactTransitionGroup = require("react-transition-group");
var _icons = require("../icons");
var _indicatorButtonTooltip = require("./indicator-button-tooltip.css");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const IndicatorButtonTooltip = ({
  content,
  trigger,
  visible,
  onClose,
  onAppear,
  onDisappear
}) => {
  const tooltipRef = (0, _react.useRef)(null);
  const [isHidden, setIsHidden] = (0, _react.useState)(visible);
  const transitionDuration = 200;
  const transitionStyle = {
    transition: `opacity ${transitionDuration}ms ease-in-out`,
    opacity: 0
  };
  const transitionStates = {
    entering: {
      opacity: 1
    },
    entered: {
      opacity: 1
    },
    exiting: {
      opacity: 0
    },
    exited: {
      opacity: 0
    }
  };
  const onCloseClick = event => {
    event.preventDefault();
    event.stopPropagation();
    onClose === null || onClose === void 0 ? void 0 : onClose();
  };
  (0, _react.useEffect)(() => {
    setIsHidden(!visible);
  }, [visible]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: _indicatorButtonTooltip.wrapperStyle,
    role: "tooltip"
  }, /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.Transition, {
    in: !isHidden,
    onExited: onDisappear,
    onEntered: onAppear,
    timeout: transitionDuration,
    appear: true,
    mountOnEnter: true,
    unmountOnExit: true
  }, state => /*#__PURE__*/_react.default.createElement("div", {
    ref: tooltipRef,
    className: _indicatorButtonTooltip.wrapperInnerStyle,
    style: {
      ...transitionStyle,
      ...transitionStates[state]
    }
  }, content, trigger === `manual` && /*#__PURE__*/_react.default.createElement("button", {
    "aria-label": "close-tooltip-button",
    onClick: onCloseClick,
    className: _indicatorButtonTooltip.closeButtonStyle
  }, _icons.closeIcon)))));
};
var _default = IndicatorButtonTooltip;
exports.default = _default;